import { Component, inject } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.sass'],
  imports: [MatProgressSpinner, AsyncPipe],
})
export class LoadingComponent {
  private loadingService = inject(LoadingService);

  loading$ = this.loadingService.loading$;
}
